import { allTokens } from '@hopdrive/ui/tokens';

/**
 * Convert a design system elevation token to a CSS box-shadow string.
 * Reusable across chat feature components.
 */
export const getElevation = (level: typeof allTokens.elevation.level1) =>
  level.layers
    .map(l => `${l.offsetX}px ${l.offsetY}px ${l.blur}px ${l.spread}px rgba(0,0,0,${l.opacity})`)
    .join(', ');
